<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer007">
<h2 class="pn" id="_idParaDest-2"><a id="_idTextAnchor001"></a><a href="#/text/9780062859426_Contents#r_idParaDest-2">1</a></h2>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062859426_Part_1.vue?12121e8a